<template>
  <div>
    <div v-show="!showInterfaceList" style="height:100%">
      <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
        <w-obj-type-filter ref="objTypeFilter" :managetype-data="managetypeData" :selected-managetype-id="selectedManagetypeId" :init-load="true" @filter-change="onFilterChange" :except-define-ids="exceptDefineIds" :except-objtype-ids="exceptObjtypeIds" :obj-define-ids="objDefineIds" :objtype-ids="objtypeIds"/>
        <w-header-search-button @click="showSearchTool = !showSearchTool" size="mini"></w-header-search-button>
      </el-row>
      <el-table-wrapper
        v-loading="isLoading"
        :style="fitHeight ? { height: '100%' } : null"
        :fit-height="fitHeight"
        ref="objTable"
        :data="tableData"
        :total="total"
        :columns="columns"
        :show-search-tool="showSearchTool"
        remote
        pagination
        :show-custom-header="showCustomHeader"
        @condition-change="onConditionChange"
        @select="onSelect"
        @select-all="onSelectAll"
      >
        <template slot-scope="scope" slot="interface-slot">
          <i class="el-icon-search" style="cursor: pointer" @click="onClickInterfaceButton(scope.row)" />
        </template>
      </el-table-wrapper>
    </div>
    <w-interface-table
      v-show="showInterfaceList"
      ref="interfaceTable"
      :active="showInterfaceList"
      :device-data="selectedDeviceData"
      :filter-params="filterParams"
      :checked-obj-list="checkedObjList"
      :fit-height="fitHeight"
      @on-click-back-button="showInterfaceList = !showInterfaceList"
    />
  </div>
</template>

<script>
import { isEmpty, isNil, filter, cloneDeep, findIndex } from 'lodash';
import logicalGroupApi from '@/api/settings/common/logical-group';
import { columnDefault } from '@/constants/table';
import WObjTypeFilter from './ObjTypeFilter';
import WInterfaceTable from './components/InterfaceTable';

export default {
  name: 'WPhysicalObjTable',
  components: {
    WObjTypeFilter,
    WInterfaceTable,
  },
  props: {
    selectedManagetypeId: {
      type: String,
      default: null,
    },
    height: {
      type: String,
    },
    fitHeight: {
      type: Boolean,
    },
    checkedObjList: {
      type: Array,
      default: () => [],
    },
    // 제외할 objDefineId들을 배열로 정의한다
    exceptDefineIds: {
      type: Array,
    },
    // 제외할 objtypeId들을 배열로 정의한다.
    exceptObjtypeIds: {
      type: Array,
    },
    // 필터링할 objDefineId들을 배열로 정의한다.
    objDefineIds: {
      type: Array,
    },
    // 필터링할 objtypeId들을 배열로 정의한다.
    objtypeIds: {
      type: Array,
    },
    // 네트워크 장비를 부모로 가지는 관리 대상 숨김 여부
    hiddenNetdeviceChildren: {
      type: Boolean,
      default: false,
    },
    managetypeData: {
      type: Array,
    },
    vmTemplateFlag: {
      type: String,
      default: null,
    },
    active: {
      type: Boolean,
      default: true,
    },
    // 권한관련 설정에서는 인터페이스가 필요가 없기때문에 인터페이스 컬럼을 보여주지 않는다
    showInterfaceColumn: {
      type: Boolean,
      default: true,
    },
    showNetdeviceSelection: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoading: false,
      showSearchTool: false,
      showCustomHeader: true,
      showInterfaceList: false,
      tableData: null,
      originTableData: null,
      total: null,
      columnDefault,
      columns: [],
      filterParams: null,
      selectedDeviceData: {},
    };
  },
  watch: {
    managetypeData: {
      handler() {
        this.$refs.objTypeFilter.loadManagetype();
      },
    },
    filterParams: {
      handler(to, from) {
        if (!isEmpty(to)) {
          if (isEmpty(from) || to.params.managetypeId !== from.params.managetypeId || to.params.managetypeKey !== from.params.managetypeKey) {
            // TODO columns를 변경하더라도 label이 변경되지 않는 문제있어 빈 columns을 먼저 주고 관리 구분에 맞는 컬럼을 설정하도록 함.
            // v-for에서 재사용으로 인한 문제로 파악되며 근본적인 해결책을 찾을 경우 해당 로직 수정 필요
            this.columns = [];
            this.$refs.objTable.clearFilter();
            this.$nextTick(() => {
              const managetypeId = to.params.managetypeId;
              if (managetypeId === 'NMS') {
                const netdeviceColumns = cloneDeep(to.columns);
                if (!this.showNetdeviceSelection) {
                  const selectionColumn = netdeviceColumns.find((column) => column.type === 'selection');
                  netdeviceColumns.splice(netdeviceColumns.indexOf(selectionColumn), 1);
                }
                if (this.showInterfaceColumn) {
                  netdeviceColumns.push({
                    label: '인터페이스',
                    width: 100,
                    align: 'center',
                    scopedSlot: 'interface-slot',
                  });
                }
                this.columns = netdeviceColumns;
              } else {
                this.columns = to.columns;
              }
            });
          }
          this.loadData();
        }
      },
    },
    active: {
      handler(value) {
        if (!isNil(value) && value) {
          this.loadData();
        } else {
          this.initData();
        }
      },
    },
  },
  methods: {
    initData() {
      this.showSearchTool = false;
      this.showInterfaceList = false;
      this.$refs.objTypeFilter.loadManagetype();
    },
    /**
     * 물리 그룹 관리 대상 데이터를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      if (!this.active) {
        return;
      }
      this.isLoading = true;
      const tableParams = {
        ...this.filterParams.params,
        ...this.$refs.objTable.getParameter(),
      };
      if (!isNil(this.vmTemplateFlag)) {
        tableParams.vmTemplateFlag = this.vmTemplateFlag;
      }
      if (!isEmpty(this.exceptDefineIds)) {
        tableParams.exceptDefineIds = this.exceptDefineIds;
      }
      if (!isEmpty(this.exceptObjtypeIds)) {
        tableParams.exceptObjtypeIds = this.exceptObjtypeIds;
      }
      if (!isEmpty(this.objDefineIds)) {
        tableParams.objDefineIds = this.objDefineIds;
      }
      if (!isEmpty(this.objtypeIds)) {
        tableParams.objtypeIds = this.objtypeIds;
      }
      if (this.hiddenNetdeviceChildren) {
        tableParams.hiddenNetdeviceChildren = this.hiddenNetdeviceChildren;
      }
      logicalGroupApi
        .getPhysicalObjList(tableParams)
        .then((response) => {
          const result = response.data;
          if (!isEmpty(result) && result.success === true && !isEmpty(result.data)) {
            result.data.forEach((row) => {
              const checkedObj = this.checkedObjList.find((obj) => obj.objId === row.objId);
              row.checked = !isNil(checkedObj) ? 1 : 0;
            });
            this.tableData = result.data;
            this.total = result.total;
            const originalData = filter(result.data, (item) => item.checked);
            this.originTableData = originalData;
            this.$nextTick(() => {
              this.toggleRowSelection(originalData);
            });
          } else {
            this.tableData = [];
            this.total = 0;
          }
        })
        .catch(() => {
          // this.managegrpObjData.loading = false;
          this.tableData = [];
          this.total = 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    /**
     * 테이블 조건 변경 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onConditionChange() {
      this.loadData();
    },
    /**
     * 테이블 선택 변경 이벤트 핸들러
     * @author Ju
     * @param  {[type]} selection [description]
     * @return {[type]}           [description]
     */
    onSelect(selection, row) {
      const checkedObj = this.checkedObjList.find((obj) => obj.objId === row.objId);
      if (!isNil(checkedObj)) {
        // AP 컨트롤러의 권한을 제거할 때 하위 무선 AP 들의 권한도 함께 제거합니다.
        if (checkedObj.objDefineId === 'WIRELESS_DEVICE' && checkedObj.objtypeId === 'AP_CONTROLLER') {
          this.checkedObjList.forEach((o) => {
            if (!isNil(o.parentObjId)) {
              if (o.parentObjId === checkedObj.objId) {
                const checked = this.$refs.objTable.getTable().selection;
                const index = findIndex(checked, (s) => s.objId === o.objId);
                if (index >= 0) {
                  checked.splice(index, 1);
                }
                this.checkedObjList.splice(this.checkedObjList.indexOf(o), 1);
              }
            }
          });
        }
        this.checkedObjList.splice(this.checkedObjList.indexOf(checkedObj), 1);
      } else {
        this.checkedObjList.push(row);
      }
    },
    onSelectAll(selection) {
      const tableData = this.tableData;
      tableData.forEach((row) => {
        const checkedObj = this.checkedObjList.find((obj) => obj.objId === row.objId);
        if (selection.length > 0) {
          if (isNil(checkedObj)) {
            this.checkedObjList.push(row);
          }
        } else if (selection <= 0) {
          if (!isNil(checkedObj)) {
            this.checkedObjList.splice(this.checkedObjList.indexOf(checkedObj), 1);
          }
        }
      });
    },
    /**
     * 선택된 데이터 배열 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getSelection() {
      return this.$refs.objTable.getTable().selection;
    },
    /**
     * 테이블 행 선택을 토글한다.
     * @author Ju
     * @param  {[type]} rows [description]
     * @return {[type]}      [description]
     */
    toggleRowSelection(rows) {
      rows.forEach((row) => {
        this.$refs.objTable.getTable().toggleRowSelection(row);
      });
    },
    /**
     * 모든 행 선택을 해제한다.
     * @author Ju
     * @return {[type]} [description]
     */
    clearSelection() {
      this.$refs.objTable.getTable().clearSelection();
    },
    setCheckObjTable() {
      this.$refs.interfaceTable.setCheckObjTable();
      if (!isNil(this.tableData)) {
        this.tableData.forEach((row) => {
          const checkedObj = this.checkedObjList.find((obj) => obj.objId === row.objId);
          row.checked = !isNil(checkedObj) ? 1 : 0;
        });
        const originalData = filter(this.tableData, (item) => item.checked);
        this.$nextTick(() => {
          this.clearSelection();
          this.toggleRowSelection(originalData);
        });
      }
    },
    /**
     * 장비 구분 조건 변경 이벤트 핸들러
     * @author Ju
     * @param  {Object} params 장비 구분 조건 객체
     * @param  {Array} columns 장비 구분 컬럼
     */
    onFilterChange(params, columns) {
      this.filterParams = {
        params,
        columns,
      };
    },
    onClickInterfaceButton(row) {
      this.selectedDeviceData = row;
      this.showInterfaceList = !this.showInterfaceList;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/table/PhysicalObjTable/index.vue